<template>
  <div>
    <v-container fluid>
      <v-card class="reportdata-card-main">

        <v-card-title class="d-flex align-center justify-space-between px-0">
          <h3 class="text-h5 font-weight-bold" color="#171717">{{ $t('questionReportManagement') }}</h3>
        </v-card-title>

        <v-divider class="model-all-divider"></v-divider>

        <v-card-text style="padding: 0">
          <div class="reportdata-filters-wrapper">
            <!-- Filter Row -->
            <div class="reportdata-filter-card">
              <div class="reportdata-filter-header">
                <img src="@/assets/material-symbols_arrow-range-rounded.svg" alt="Date range" width="20" height="20" />
                <span class="reportdata-filter-title">{{ $t('dateRange') }}</span>
              </div>
              <v-row class="items-center justify-between mt-2">
                <!-- Start Date -->
                <v-col cols="12" md="4">
                  <div class="mb-1 d-flex align-center" style="gap: 2px">
                    <label for="Start Date" class="text-sm font-medium text-gray-700">
                      {{ $t('startDate') }}
                    </label>
                    <v-tooltip location="top" max-width="230px">
                      <template v-slot:activator="{ props }">
                        <img v-bind="props" src="@/assets/intent group toolip.svg" alt="info" width="18" height="18"
                          style="cursor: pointer; margin-left: 4px;" />
                      </template>
                      <span>{{ $t('selectStartDateFilter') }}</span>
                    </v-tooltip>
                  </div>
                  <v-menu v-model="startDateFlag" :close-on-content-click="false" transition="scale-transition"
                    location="bottom" min-width="auto">
                    <template #activator="{ props }">
                      <v-text-field
                        :model-value="formatDateDisplay(startDate)"
                        :placeholder="$t('Select date')"
                        readonly
                        variant="outlined"
                        v-bind="props"
                        density="compact"
                        class="reportdata-field-date mt-1"
                        clearable
                        @click:clear="clearStartDate"
                        hide-details
                      >
                        <template #prepend-inner>
                          <img src="@/assets/Icons/new_calendar.png" alt="calendar" style="width: 20px; height: 20px;" />
                        </template>
                      </v-text-field>
                    </template>
                    <v-date-picker
                      v-model="startDate"
                      :key="`start-${startPickerYear}-${startPickerMonth}`"
                      :year="startPickerYear"
                      :month="startPickerMonth"
                      @update:year="startPickerYear = $event"
                      @update:month="startPickerMonth = $event"
                      :max="new Date().toISOString().substr(0, 10)"
                      @update:model-value="
                        (val) => {
                          startDate = formatDate(val);
                          startDateFlag = false;
                        }
                      "
                      show-adjacent-months
                      class="date-picker">
                      <template #header>
                        <div class="picker-header-custom d-flex align-center justify-space-between px-4 py-3">
                          <div class="text-h6 font-weight-medium">{{ getFormattedHeaderDate(startPickerYear, startPickerMonth, startDate) }}</div>
                          <v-select
                            v-model="startPickerYear"
                            :items="years"
                            density="compact"
                            variant="plain"
                            hide-details
                            class="month-year-select"
                            style="width: 100px;"
                          ></v-select>
                        </div>
                      </template>
                    </v-date-picker>
                  </v-menu>
                </v-col>

                <div class="date-divider">-</div>

                <!-- End Date -->
                <v-col cols="12" md="4">
                  <div class="mb-1 d-flex align-center" style="gap: 2px">
                    <label for="End Date" class="text-sm font-medium text-gray-700">
                      {{ $t('endDate') }}
                    </label>
                    <v-tooltip location="top" max-width="230px">
                      <template v-slot:activator="{ props }">
                        <img v-bind="props" src="@/assets/intent group toolip.svg" alt="info" width="18" height="18"
                          style="cursor: pointer; margin-left: 4px;" />
                      </template>
                      <span>{{ $t('selectEndDateFilter') }}</span>
                    </v-tooltip>
                  </div>
                  <v-menu v-model="endDateFlag" :close-on-content-click="false" transition="scale-transition"
                    location="bottom" min-width="auto">
                    <template #activator="{ props }">
                      <v-text-field
                        :model-value="formatDateDisplay(endDate)"
                        :placeholder="$t('Select date')"
                        readonly
                        variant="outlined"
                        v-bind="props"
                        density="compact"
                        class="reportdata-field-date mt-1"
                        clearable
                        @click:clear="clearEndDate"
                        hide-details
                      >
                        <template #prepend-inner>
                          <img src="@/assets/Icons/new_calendar.png" alt="calendar" style="width: 20px; height: 20px;" />
                        </template>
                      </v-text-field>
                    </template>
                    <v-date-picker
                      v-model="endDate"
                      :key="`end-${endPickerYear}-${endPickerMonth}`"
                      :year="endPickerYear"
                      :month="endPickerMonth"
                      @update:year="endPickerYear = $event"
                      @update:month="endPickerMonth = $event"
                      :min="startDate != null ? startDate : null"
                      @update:model-value="
                        (val) => {
                          endDate = formatDate(val);
                          endDateFlag = false;
                        }
                      "
                      color="#C32E0E"
                      class="date-picker">
                      <template #header>
                        <div class="picker-header-custom d-flex align-center justify-space-between px-4 py-3">
                          <div class="text-h6 font-weight-medium">{{ getFormattedHeaderDate(endPickerYear, endPickerMonth, endDate) }}</div>
                          <v-select
                            v-model="endPickerYear"
                            :items="years"
                            density="compact"
                            variant="plain"
                            hide-details
                            class="month-year-select"
                            style="max-width: 90px;"
                          ></v-select>
                        </div>
                      </template>
                    </v-date-picker>
                  </v-menu>
                </v-col>

                <!-- Process Prompt-->
                <v-col cols="12" md="3" class="d-flex align-end justify-end ml-auto">
                  <v-divider vertical class="reportdata-filter-divider"></v-divider>
                  <div class="reportdata-action-group">
                    <v-btn
                      id="button-process-reportquestiontop10"
                      variant="elevated"
                      size="large"
                      @click="Search()"
                      :disabled="isProcessDisabled"
                      :class="processButtonClass">
                      <v-img :src="processIcon" alt="Process Icon" class="template-icon" />
                      {{ $t('process') }}
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </div>
          </div>

          <!-- Prompt Template Section -->
          <v-card class="reportdata-card-outlined reportdata-question-prompt-card mx-0 my-5">

            <div class="prompt-title-container">
              <v-img :src="promptTemplateIcon" alt="Prompt Template Icon" class="template-icon" />
              {{ $t('Prompt Template') }}
            </div>

            <v-card-text class="pa-5">
              <v-textarea id="prompttemplate-textarea-reportquestiontop10" variant="outlined" counter auto-grow rows="5"
                v-model="promptTemplate" :maxlength="maxLengthChar" rounded="xl"
                :rules="[validatePrompt(promptTemplate)]" required color="#C9C9C9" prepend-inner-icon="mdi-code-tags"
                clearable>
                <template #append-inner>
                  <v-tooltip location="top" max-width="300">
                    <template #activator="{ props }">
                      <v-icon size="small" color="gray-darken-1" v-bind="props">
                        mdi-information-outline
                      </v-icon>
                    </template>
                    <span>
                      {{ $t('_promptTemplateHint') }}
                    </span>
                  </v-tooltip>
                </template>
              </v-textarea>
            </v-card-text>
          </v-card>

          <!-- Data Table with Modern Styling -->
          <v-card class="reportdata-card-table">
            <v-row no-gutters class="pb-4">
              <v-col cols="12" md="6" class="d-flex justify-start align-middle">
                <h2 color="#171717" class="font-weight-bold">{{ $t('questionReportData') }}</h2>
              </v-col>
              <v-col cols="12" md="6" class="d-flex justify-end align-middle">
                <div class="d-flex align-center justify-center">
                  <v-chip size="large" :color="dataUpdate === dataAll && dataAll > 0
                    ? '#2ABF56'
                    : '#EABD07'
                    " variant="elevated" class="px-4 text-white">
                    <v-icon class="mr-2" color="white">
                      {{
                        dataUpdate === dataAll && dataAll > 0
                          ? "mdi-check-circle"
                          : "mdi-clock-outline"
                      }}
                    </v-icon>
                    {{ dataUpdate }} / {{ dataAll }}
                  </v-chip>
                </div>
                <v-tooltip location="top" max-width="200">
                  <template #activator="{ props }">
                    <v-btn v-bind="props" icon class="reportdata-icon-btn reportdata-icon-btn--ghost ml-2"
                      variant="flat" @click="AutoRefresh()" aria-label="Reset filters">
                      <v-icon size="24">mdi-restore</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t('refresh') }}</span>
                </v-tooltip>
              </v-col>
            </v-row>

            <div class="reportdata-table-container">
              <v-data-table-server
                v-model:options="options"
                :items="pagedItems"
                :items-length="dataTable.length"
                :headers="headers"
                hide-default-footer
                class="reportdata-table-modern"
                density="comfortable"
                :items-per-page="options.itemsPerPage"
                hover>

                <template v-slot:no-data>
                    <div class="d-flex align-center justify-center">{{ $t('noDataAvailable') }}</div>
                  </template>

                <template #item="{ item }">
                  <tr class="reportdata-table-row">
                    <td class="text-center">
                      {{ item.no }}
                    </td>
                    <td>
                      <div class="reportdata-text-container">
                        <span v-for="(subItem, index) in item.title" :key="subItem" class="reportdata-text-standard">
                          {{ subArray(subItem, index, item.title.length) }}
                        </span>
                      </div>
                    </td>
                    <td class="text-center">
                      {{ substringLong(item.count) }}
                    </td>
                  </tr>
                </template>
                <template v-slot:bottom>
                  <div class="table-bottom-group">
                    <div class="d-flex justify-space-between align-center px-4 py-2" style="width: 100%">
                      <div class="d-flex flex-column">
                        <span>{{ $t('totalResults') }} {{ dataTable.length }}</span>
                      </div>

                      <v-data-table-footer
                        :items-per-page-options="itemsPerPageOptions"
                        v-model:items-per-page="options.itemsPerPage"
                        v-model:page="options.page"
                        :length="pageCount"
                      />
                    </div>
                  </div>
                </template>
              </v-data-table-server>
            </div>
          </v-card>
        </v-card-text>
      </v-card>
    </v-container>
    <v-overlay :value="loading">
      <v-dialog v-model="loading" persistent width="300">
        <v-card color="#1976D2" dark>
          <v-card-text class="white--text">
            {{ $t('loadingPleaseWait') }}
            <v-progress-linear indeterminate color="#FAA91B" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-overlay>
  </div>
</template>
<script>
import checkPermissionTwo from "@/api/function.js";
const LogTrace = checkPermissionTwo;
import processIcon from "@/assets/Icons/report-process.svg";
import promptTemplateIcon from "@/assets/Icons/prompt-template-icon.svg";

export default {
  name: "ReportQuestion",
  inject: ["flagNav", "FontColorTitle", "SubNavbarBackGround"],
  mixins: [checkPermissionTwo, LogTrace],
  data() {
    const currentDate = new Date();
    return {
      today: null,
      loading: false,
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
      },

      startDateFlag: false,
      endDateFlag: false,
      startDate: null,
      endDate: null,
      promptTemplate: "",
      maxLengthChar: 4000,
      dataUpdate: 0,
      dataAll: 0,
      dataTable: [],

      processIcon: processIcon,
      promptTemplateIcon: promptTemplateIcon,

      // Date picker state management
      startPickerYear: currentDate.getFullYear(),
      startPickerMonth: currentDate.getMonth(),
      endPickerYear: currentDate.getFullYear(),
      endPickerMonth: currentDate.getMonth(),
      
      years: Array.from({ length: 10 }, (_, i) => currentDate.getFullYear() - i),
    };
  },
  computed: {
    itemsPerPageOptions() {
      return [
        { title: "10", value: 10 },
        { title: "25", value: 25 },
        { title: "50", value: 50 },
        { title: "100", value: 100 },
        { title: this.$t("all"), value: -1 },
      ];
    },
    headers() {
      return [
        {
          title: this.$t("no"),
          align: "center",
          width: "100px",
          sortable: false,
        },
        {
          title: this.$t("questionCategory"),
          align: "left",
          sortable: false,
          width: "500px",
        },
        {
          title: this.$t("totalCol"),
          align: "center",
          sortable: false,
          width: "100px",
        },
      ];
    },
    pagedItems() {
      if (!this.options || !Array.isArray(this.dataTable)) {
        return [];
      }
      const perPage = this.options.itemsPerPage;
      if (!perPage || perPage === -1) {
        return this.dataTable;
      }
      const start = (this.options.page - 1) * perPage;
      return this.dataTable.slice(start, start + perPage);
    },
    pageCount() {
      if (!this.dataTable.length) {
        return 0;
      }
      const perPage = this.options.itemsPerPage;
      if (!perPage || perPage === -1) {
        return 1;
      }
      return Math.ceil(this.dataTable.length / perPage);
    },
    isProcessDisabled() {
      const hasStart = typeof this.startDate === "string" && this.startDate.trim().length > 0;
      const hasEnd = typeof this.endDate === "string" && this.endDate.trim().length > 0;
      const hasPrompt = typeof this.promptTemplate === "string" && this.promptTemplate.trim().length > 0;
      return !(hasStart && hasEnd && hasPrompt);
    },
    processButtonClass() {
      return [
        "reportdata-btn-process",
        { "reportdata-btn-process--active": !this.isProcessDisabled },
      ];
    },
  },
  watch: {
    startDateFlag(newVal) {
      if (newVal) {
        if (this.startDate) {
          const date = new Date(this.startDate);
          this.startPickerYear = date.getFullYear();
          this.startPickerMonth = date.getMonth();
        } else {
          const today = new Date();
          this.startPickerYear = today.getFullYear();
          this.startPickerMonth = today.getMonth();
        }
      }
    },
    endDateFlag(newVal) {
      if (newVal) {
        if (this.endDate) {
          const date = new Date(this.endDate);
          this.endPickerYear = date.getFullYear();
          this.endPickerMonth = date.getMonth();
        } else {
          const today = new Date();
          this.endPickerYear = today.getFullYear();
          this.endPickerMonth = today.getMonth();
        }
      }
    },
  },
  methods: {

    validatePrompt(inputValue) {
      if (!inputValue) {
        return true;
      }
      if (this.maxLengthChar == null) {
        return true;
      } else {
        return (
          inputValue.length <= this.maxLengthChar ||
          this.$t("_maxLengthExceeded", {
            max: this.convertNumberToStringFormat(this.maxLengthChar),
          })
        );
      }
    },


    convertNumberToStringFormat(value) {
      const [intPart, decPart] = value.toString().split('.');
      const grouped = intPart.split('').reverse().join('').replace(/(\d{3})(?=\d)/g, "$1,").split('').reverse().join('');
      return decPart !== undefined ? `${grouped}.${decPart}` : grouped;
    },

    clearStartDate() {
      this.startDate = null;
    },

    clearEndDate() {
      this.endDate = null;
    },

    Search() {
      if (this.isProcessDisabled) {
        return;
      }
      this.loading = true;
      this.QuestionGenerate();
    },

    QuestionGenerate() {
      this.loading = true;

      if (
        this.startDate != null &&
        this.endDate != null &&
        this.promptTemplate != null &&
        this.promptTemplate != ""
      ) {
        let temp = {
          StartDate: this.startDate,
          EndDate: this.endDate,
          Prompt: this.promptTemplate,
        };

        this.$call.QuestionGenerate(
          temp,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              this.dataUpdate = dataResponse.data.processingCompleted;
              this.dataAll = dataResponse.data.processAll;
              this.AutoRefresh();
            }
            this.loading = false;
          },
          (errorResource) => {
            this.loading = false;
            console.error(errorResource);
          }
        );
      } else {
        this.$swal.fire({
          icon: "warning",
          title: this.$t("warning"),
          text: this.$t("pleaseFillRequiredFields"),
          showConfirmButton: false,
          timer: 1800,
        });
        this.loading = false;
      }
    },

    async AutoRefresh() {
      let death_waiting = true;
      do {
        this.GetReport();
        if (
          globalThis.location.pathname != "/ReportQuestionTop10" ||
          this.dataUpdate == this.dataAll
        ) {
          death_waiting = false;
        }
        await new Promise((resolve) => setTimeout(resolve, 5000));
      } while (death_waiting);
    },

    // คืนค่าเฉพาะ prompt ของรายงานล่าสุด ไม่แตะ startDate/endDate เพราะ
    // ฟิลเตอร์วันที่ต้องเป็นวันที่ปัจจุบันเสมอ (และ AutoRefresh เรียก GetReport
    // ทุก 5 วิ ถ้าเซ็ตวันที่ตรงนี้จะทับค่าที่ผู้ใช้เพิ่งเลือก)
    applyRequestReport(requestReport) {
      this.promptTemplate = requestReport.prompt;
    },

    GetReport() {
      let temp = {};

      this.$call.GetReportQuestion(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            if (dataResponse.data.requestReport != null) {
              this.applyRequestReport(dataResponse.data.requestReport);
            }
            this.dataUpdate = dataResponse.data.processingCompleted;
            this.dataAll = dataResponse.data.processAll;
            this.dataTable = dataResponse.data.listData ?? [];

            const perPage = this.options.itemsPerPage;
            if (!perPage || perPage === -1) {
              this.options.page = 1;
            } else {
              const maxPage = Math.max(1, Math.ceil(this.dataTable.length / perPage));
              if (this.options.page > maxPage) {
                this.options.page = maxPage;
              }
            }
          } else {
            this.dataTable = [];
            this.options.page = 1;
          }
        },
        (errorResource) => {
          console.error(errorResource);
        }
      );
    },



    substringLong(value) {
      if (value == null) {
        return "-";
      }
      if (value.length > 81) {
        return value.substring(0, 80) + ".....";
      }
      return value;
    },

    subArray(value, index, sum) {
      if (index == sum - 1) {
        return value;
      } else {
        return value + ", ";
      }
    },
  },
  mounted() {
    this.GetDate();
    const date = new Date();
    this.endDate = this.convertDateToString2(date);
    this.startDate = this.convertDateToString2(date);
    this.GetReport();
  },
};
</script>
<style scoped>
.reportdata-field-date :deep(.v-field) {
  border-radius: 16px !important;
}

.reportdata-question-prompt-card {
  background: #ffffff !important;
  box-shadow: unset !important;
}

.reportdata-card-main {
  overflow: hidden;
  background: #ffffff !important;
  box-shadow: unset !important;
}

.model-all-divider {
  width: 100% !important;
  border-color: #CCCCCC !important;
  height: 2px !important;
  opacity: 1 !important;
  margin: 5px 0px 25px 0px !important;
}

.reportdata-filters-wrapper {
  padding: 0px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.reportdata-filter-card {
  background: transparent;
  border: 1px solid #C9C9C9;
  border-radius: 18px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.date-style {
  border: 1px solid #c9c9c9;
  border-radius: 10px;
  height: 40px;
  background: #ffffff;
}

.date-style :deep(.v-field__outline),
.date-style :deep(.v-field__overlay) {
  display: none;
}

.date-style :deep(.v-field) {
  min-height: 40px;
}

.date-style :deep(.v-field__input) {
  padding: 8px 0 8px 4px;
  color: #1f1f1f;
  font-weight: 600;
  font-size: 14px;
  min-height: 40px;
}

.date-style :deep(.v-field__prepend-inner) {
  padding-top: 8px;
  padding-left: 4px;
}

.date-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex: 0 0 232px;
  max-width: 100%;
  min-width: 200px;
}

.date-label-wrapper {
  display: flex;
  align-items: center;
  gap: 4px;
}

.date-label {
  color: #4b4b4b;
  font-weight: 600;
  font-size: 14px;
}

.date-tooltip-icon {
  cursor: pointer;
}

.reportdata-filter-header {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 16px;
}

.date-divider {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #646464;
  font-weight: 700;
  font-size: 30px;
  padding-top: 20px;
  margin: 10px;
}

.reportdata-filter-divider {
  height: 50px;
  align-self: flex-end;
  margin: 0 25px 0px 15px;
  border-color: #C9C9C9 !important;
  opacity: 1;
}

.reportdata-btn-process {
  color: #ffffff;
  border-radius: 16px;
  background: #727378;
  transition: background 0.2s ease-in-out, opacity 0.2s ease-in-out;
}

.reportdata-btn-process:disabled {
  opacity: 0.75;
  cursor: not-allowed;
}

.reportdata-btn-process--active {
  background: linear-gradient(90deg, #C32E0E 0%, #F67760 100%) !important;
  color: #ffffff !important;
}

.template-icon {
  width: 25px;
  height: 25px;
  margin-right: 10px;
  max-width: 25px;
  max-height: 25px;
  flex-shrink: 0;
  object-fit: contain;
}

.reportdata-card-table {
  border: 1px solid #c9c9c9 !important;
  border-radius: 18px !important;
  overflow: hidden;
  box-shadow: none !important;
  margin: 5px 0px;
  padding: 20px;
}

.prompt-title-container {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  padding: 15px 20px 0 20px;
}

.reportdata-icon-btn {
  border-radius: 50%;
  height: 42px;
  width: 42px;
  min-width: 42px;
  transform: scaleX(-1);
}

.reportdata-icon-btn--ghost {
  background: #ffffff !important;
  color: #171717 !important;
  border: 1px solid #d0d0d0 !important;
}

:deep(thead) {
  background-color: #FFF2F2 !important;
  padding: 0 8px;
}
.v-table--has-top :deep(.v-table__wrapper) {
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}

:deep(.v-data-table .v-table__wrapper > table > thead > tr th.v-data-table-column--align-left .v-data-table-header__content span) {
  font-weight: 600;
  font-size: 14px;
}
:deep(.v-data-table .v-table__wrapper > table > thead > tr th.v-data-table-column--align-center .v-data-table-header__content span) {
  font-weight: 600;
  font-size: 14px;
}
</style>
